import React, { useEffect, useState } from "react";

import { EditOutlined } from "@ant-design/icons";
import { Card, Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { dispatch, useSelector } from "../../redux/store";
import Loading from "../../global/item/Loading/loading";
import TitleComponent from "../../global/Custom/TitleComponent/TitleComponent";
import { getContactDetail } from "../../redux/action/contact";
function ContactPage() {
  const {t} = useTranslation();
  const {contactDetail} = useSelector(state => state.contact)
  const [loading,setLoading] = useState(true);

  useEffect(() => {
    dispatch(getContactDetail())
    .then(() => setLoading(false)) 
      .catch(error => {
        
        setLoading(false); 
      });
  },[])
  return (
  
    <div>
      {loading?<Loading/>: <div>
      <TitleComponent
        title={"Liên hệ"}
        type="primary"
        icon={<EditOutlined />}
        data={t('edit')}
        to={"/Contact/Edit"}
      />
      <Card className="layoutItem">
        <h3 style={{ color: `var(--primary-color)`, marginBottom: 8 }}>
          {t('basicInformation')}
        </h3>
        <Row gutter={[20, 0]}>
          <Col xl={24}>
              <p className="tilteForm">{"Địa chỉ"}</p>
              <p className="descForm">{contactDetail.address}</p>
            </Col>
            <Col xl={24}>
              <p className="tilteForm">{"Link maps"}</p>
              <p className="descForm">{contactDetail.linkAddress}</p>
            </Col>
            <Col xl={24}>
              <p className="tilteForm">{"Số điện thoại 1"}</p>
              <p className="descForm">{contactDetail.contact1}</p>
            </Col>
            <Col xl={24}>
              <p className="tilteForm">{"Số điện thoại 2"}</p>
              <p className="descForm">{contactDetail.contact2}</p>
            </Col>
             <Col xl={24}>
              <p className="tilteForm">{"Số điện thoại 3"}</p>
              <p className="descForm">{contactDetail.contact3}</p>
            </Col>
            <Col xl={24}>
              <p className="tilteForm">{"Số điện thoại 4"}</p>
              <p className="descForm">{contactDetail.contact4}</p>
            </Col>
            <Col xl={24}>
              <p className="tilteForm">{"Mail"}</p>
              <p className="descForm">{contactDetail.email}</p>
            </Col>
        </Row>
      </Card>
  
      </div>}
     
      
    </div>
  );
}

export default ContactPage;
